// src/components/Testimonial.js
import React from 'react';
import Slider from 'react-slick';
import '../css/Testimonial.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const testimonials = [
  {
    text: "Everything in the house is useful, or believe to be beautiful. Thanks to No Brokerage Paying Guest management for working like quick response team and keeping flat in spick and span condition as always.",
    author: "Shikha Badlani",
  },
  {
    text: "The support team is extremely responsive and helpful. My entire move-in process was seamless and stress-free.",
    author: "Rahul Mehra",
  },
  {
    text: "Highly professional service. I found a great place with no hassle. Thank you No Brokerage Paying Guest!",
    author: "Pooja Sinha",
  },
  {
    text: "Clean and well-maintained properties. The management really cares about the comfort of the tenants.",
    author: "Neha Sharma",
  },
  {
    text: "Smooth booking, transparent policies, and no hidden charges. Highly recommend their service!",
    author: "Arjun Verma",
  },
];

const settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  speed: 800,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

const Testimonial = () => {
  return (
    <div className="testimonial-section">
      <Slider {...settings}>
        {testimonials.map((item, index) => (
          <div className="testimonial-card" key={index}>
            <p className="testimonial-text">“{item.text}”</p>
            <p className="testimonial-author"><strong>{item.author}</strong></p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Testimonial;
